import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "p-field p-col" }
const _hoisted_3 = { for: "sector" }
const _hoisted_4 = { class: "p-field p-col" }
const _hoisted_5 = { for: "function" }
const _hoisted_6 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_7 = { class: "p-field p-col" }
const _hoisted_8 = { for: "hr_last_name" }
const _hoisted_9 = { class: "p-field p-col" }
const _hoisted_10 = { for: "hr_fistname" }
const _hoisted_11 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_12 = { class: "p-field p-col" }
const _hoisted_13 = { for: "hr_entry_date" }
const _hoisted_14 = { class: "p-field p-col" }
const _hoisted_15 = { for: "hr_departure_date" }
const _hoisted_16 = { class: "p-field" }
const _hoisted_17 = { for: "contacts" }
const _hoisted_18 = { class: "p-field p-mt-3" }

import { useEmployeeForm } from "./hooks/useEmployeeForm";


export default /*#__PURE__*/_defineComponent({
  __name: 'EmployeeForm',
  emits: ["validate"],
  setup(__props, { expose: __expose, emit: __emit }) {

const emit = __emit;
const {
  setIdentity,
  setCV,
  removeIdentity,
  validateFields,
  removeCv,
  resetFields,
  form,
  hasError,
  functions,
  _functionsLoading,
  sectors,
  _sectorsLoading,
} = useEmployeeForm();

__expose({ validateFields, resetFields, hasError });

const submit = () => {
  validateFields().then((input) => {
    emit("validate", input);
  });
};

return (_ctx: any,_cache: any) => {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_FileUpload = _resolveComponent("FileUpload")!

  return (_openBlock(), _createElementBlock("form", {
    autocomplete: "off",
    class: "p-fluid",
    onSubmit: _withModifiers(submit, ["prevent"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t("sector")), 1),
        _createVNode(_component_Dropdown, {
          modelValue: _unref(form).sectorId.$value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).sectorId.$value) = $event)),
          options: _unref(sectors),
          optionLabel: "name",
          "option-value": "id",
          "data-key": "id",
          filter: true,
          display: "chip",
          "filter-fields": ['name'],
          filterPlaceholder: _ctx.$t('search'),
          loading: _unref(_sectorsLoading)
        }, null, 8, ["modelValue", "options", "filterPlaceholder", "loading"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t("function")), 1),
        _createVNode(_component_Dropdown, {
          modelValue: _unref(form).functionId.$value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).functionId.$value) = $event)),
          options: _unref(functions),
          optionLabel: "name",
          "option-value": "id",
          "data-key": "id",
          filter: true,
          display: "chip",
          "filter-fields": ['name'],
          filterPlaceholder: _ctx.$t('search'),
          loading: _unref(_functionsLoading)
        }, null, 8, ["modelValue", "options", "filterPlaceholder", "loading"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t("hr_last_name")), 1),
        _createVNode(_component_InputText, {
          id: "hr_last_name",
          modelValue: _unref(form).lastName.$value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).lastName.$value) = $event)),
          onInput: _cache[3] || (_cache[3] = ($event: any) => (_unref(form).lastName.$validate())),
          class: _normalizeClass({ 'p-invalid': _unref(form).lastName.$hasError })
        }, null, 8, ["modelValue", "class"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t("hr_fistname")), 1),
        _createVNode(_component_InputText, {
          id: "hr_fistname",
          modelValue: _unref(form).firstName.$value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(form).firstName.$value) = $event)),
          onInput: _cache[5] || (_cache[5] = ($event: any) => (_unref(form).firstName.$validate())),
          class: _normalizeClass({ 'p-invalid': _unref(form).firstName.$hasError })
        }, null, 8, ["modelValue", "class"])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t("hr_entry_date")), 1),
        _createVNode(_component_Calendar, {
          modelValue: _unref(form).entryDate.$value,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(form).entryDate.$value) = $event)),
          dateFormat: _ctx.$t('prime.dateFormat')
        }, null, 8, ["modelValue", "dateFormat"])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t("hr_departure_date")), 1),
        _createVNode(_component_Calendar, {
          modelValue: _unref(form).departureDate.$value,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(form).departureDate.$value) = $event)),
          dateFormat: _ctx.$t('prime.dateFormat')
        }, null, 8, ["modelValue", "dateFormat"])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t("contacts")), 1),
      _createVNode(_component_Textarea, {
        id: "contacts",
        modelValue: _unref(form).contacts.$value,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(form).contacts.$value) = $event)),
        onInput: _cache[9] || (_cache[9] = ($event: any) => (_unref(form).contacts.$validate())),
        class: _normalizeClass({ 'p-invalid': _unref(form).contacts.$hasError })
      }, null, 8, ["modelValue", "class"])
    ]),
    _createVNode(_component_FileUpload, {
      "choose-label": _ctx.$t('hr_choose_cv'),
      accept: "image/*, .pdf, .doc, .docx",
      "show-cancel-button": false,
      "show-upload-button": false,
      multiple: false,
      "choose-icon": "pi pi-image",
      "file-limit": 1,
      onSelect: _unref(setCV),
      onRemove: _unref(removeCv)
    }, null, 8, ["choose-label", "onSelect", "onRemove"]),
    _createElementVNode("div", _hoisted_18, [
      _createVNode(_component_FileUpload, {
        "choose-label": _ctx.$t('hr_choose_identity'),
        accept: "image/*, .pdf, .doc, .docx",
        "show-cancel-button": false,
        "show-upload-button": false,
        multiple: false,
        "choose-icon": "pi pi-image",
        "file-limit": 1,
        onSelect: _unref(setIdentity),
        onRemove: _unref(removeIdentity)
      }, null, 8, ["choose-label", "onSelect", "onRemove"])
    ])
  ], 32))
}
}

})